export default {
  ZH_HK: {
    search: "搜索題目",
    startGame: "開始答題",
    shareGame: "分享題目",
    noQuestionBank: "沒有題庫",
    noTopic: "沒有題目",
    title: "學科",
    edit: "編輯",
    cover: "封面",
    add: "添加",
    _add: "",
    name: "名稱",
    input: "輸入",
    grade: "適合年級",
    confirm: "確定",
    cancel: "取消",
    emptyName: "名称未填",
    questionBank: "題庫",
    course: "大綱編輯",
    mineClass: "我的教案",
    sysClass: "系統教案",
    resourceLibrary: "資源庫"
  },
  zh_cn: {
    search: "搜索题目",
    startGame: "开始答题",
    shareGame: "分享题目",
    noQuestionBank: "没有题库",
    noTopic: "没有题目",
    title: "科目",
    edit: "编辑",
    cover: "封面",
    add: "添加",
    _add: "",
    name: "名称",
    input: "输入",
    grade: "适合年级",
    confirm: "确定",
    cancel: "取消",
    emptyName: "名称未填",
    questionBank: "题库",
    course: "大纲编辑",
    mineClass: "我的教案",
    sysClass: "系统教案",
    resourceLibrary: "资源库"
  },
  EN: {
    search: "Search Questions",
    startGame: "Start Answering",
    shareGame: "Share Question",
    noQuestionBank: "No Question Bank",
    noTopic: "No Questions",
    title: "Subject",
    edit: "Edit",
    cover: "Cover",
    add: "Add",
    _add: "Add a ",
    name: "Name",
    input: "Enter",
    grade: "Grade",
    confirm: "Confirm",
    cancel: "Cancel",
    emptyName: "Name is required",
    questionBank: "Question Bank",
    course: "Course Outline",
    mineClass: "My Lesson Plans",
    sysClass: "System Lesson Plans",
    resourceLibrary: "Resource Library"
  },
  es: {
    search: "Buscar preguntas",
    startGame: "Comenzar a responder",
    shareGame: "Compartir pregunta",
    noQuestionBank: "No hay banco de preguntas",
    noTopic: "Sin preguntas",
    title: "Asignatura",
    edit: "Editar",
    cover: "Portada",
    add: "Agregar",
    _add: "Agregar un(a) ",
    name: "Nombre",
    input: "Ingresar",
    grade: "Grado",
    confirm: "Confirmar",
    cancel: "Cancelar",
    emptyName: "El nombre es obligatorio",
    questionBank: "Banco de preguntas",
    course: "Programa del curso",
    mineClass: "Mis planes de lección",
    sysClass: "Planes de lección del sistema",
    resourceLibrary: "Biblioteca de recursos"
  }
};
